import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class UnicornStudioService {
  private static scriptLoadPromise: Promise<void> | null = null;
  private scenes: Record<string, any> = {};

  loadScript(): Promise<void> {
    if (UnicornStudioService.scriptLoadPromise) {
      return UnicornStudioService.scriptLoadPromise;
    }

    UnicornStudioService.scriptLoadPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v1.4.31/dist/unicornStudio.umd.js';
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });

    return UnicornStudioService.scriptLoadPromise;
  }

  runAnimation(elementId: string, filePath: string): void {
    // @ts-ignore
    UnicornStudio.addScene({
      elementId, // id of the HTML element to render your scene in (the scene will use its dimensions)
      lazyLoad: true, // will not initialize the scene until it scrolls into view
      filePath, // if youre hosting your own exported json code, point to it here (do not use both filePath and projectId, only one is required)
      fixed: false, // whether the scene should behave like a fixed element or not. automatic by default but this gives explicit control
      altText: 'Welcome to Unicorn Studio', // optional text for SEO, going inside the <canvas> tag
      ariaLabel: 'This is a canvas scene', // optional text for the aria-label attribute on the <canvas> element
      production: false, // when true, will hit the global edge CDN, learn more in the help docs
      interactivity: {
        // [optional]
        mouse: {
          disableMobile: false, // disable touch movement on mobile
          disabled: false, // disable all mouse interaction
        },
      },
    }).then(scene => this.scenes[elementId] = scene)
      .catch(err => console.error(err));
  }

  resizeScene(id: string): void {
    this.scenes[id]?.resize();
  }

  destroyScene(id: string): void {
    this.scenes[id]?.destroy();
    delete this.scenes[id];
  }
}
